import { showToast } from './toast';

/**
 * Client-side guard for new password mismatch (server still validates).
 */
export function initProfileForm(): void {
    const form = document.querySelector<HTMLFormElement>('[data-profile-form]');
    if (!form) {
        return;
    }

    form.addEventListener('submit', (e) => {
        const prev = form.querySelector<HTMLInputElement>('[name="previous_password"]');
        const n1 = form.querySelector<HTMLInputElement>('[name="new_password"]');
        const n2 = form.querySelector<HTMLInputElement>('[name="new_password2"]');
        if (!prev || !n1 || !n2) {
            return;
        }

        const attempt =
            prev.value.trim() !== '' || n1.value.trim() !== '' || n2.value.trim() !== '';
        if (!attempt) {
            return;
        }

        if (n1.value !== n2.value) {
            e.preventDefault();
            showToast({
                variant: 'error',
                message: 'New passwords do not match.',
                durationMs: 8000,
            });
        }
    });
}
